module.exports = __webpack_public_path__ + "img/system-design-logo-color.2843a793.gif";